import type { PeopleTypes } from "enums/peopleTypes";
import { useSharedColumnBuilder } from "hooks/useSharedColumnBuilder";

type Props = {
  type: PeopleTypes;
  onCopy: (record: any) => void;
  onPreview: (record: any) => void;
};

export const useCopyPeopleSeasonsColumns = ({ type, onCopy, onPreview }: Props) => {
  const {
    createCompetitionNameColumn,
    createSeasonNameColumn,
    createGenderColumn,
    createSeasonStartDateColumn,
    createSeasonEndDateColumn,
    createSeasonAgeGroupColumn,
    createSeasonYearColumn,
    createSeasonStatusColumn,
    createCopyPeopleActionsColumn,
  } = useSharedColumnBuilder();

  return [
    createSeasonYearColumn(),
    createCompetitionNameColumn(),
    createSeasonNameColumn(),
    createGenderColumn(),
    createSeasonAgeGroupColumn(),
    createSeasonStartDateColumn(),
    createSeasonEndDateColumn(),
    createSeasonStatusColumn(),
    createCopyPeopleActionsColumn(type, onPreview, onCopy),
  ];
};
